<template>
    <div :class="['flex flex-row md:flex-col justify-start items-center md:justify-center', size]">
        <div
            v-if="icon"
            :class="[icon, 'circle-badge count-up-icon mb-0 md:mb-6 bg-contain bg-no-repeat']"
        ></div>
        <div class="text-left md:text-center px-5 md:px-0">
            <h3
                ref="numberCount"
                data-testid="number-count"
                class="font-subtitle-2"
            >
                0
            </h3>
            <slot name="label"></slot>
        </div>
    </div>
</template>

<script>
// this is a wrapper around the plugin
import CountUpInstance from '@plugins/countUp';

/**
 * Number count component that can be adjusted to support an icon and a text
 */
export default {
    name: 'CountUpItem',
    props: {
        /**
         *  When this property turns to true, the component will start counting
         */
        shouldStart: {
            type: Boolean,
            required: true,
            default: false,
        },
        /**
         *  Inject full class name e.g "circle-icon course" (optional)
         */
        icon: {
            type: String,
            required: false,
            default: null,
        },
        /**
         *  The number where the count should stop (required)
         */
        end: {
            type: Number,
            required: true,
            validator(value) {
                return value >= 0;
            },
        },
        /**
         *  The delay in milliseconds until the count starts (optional)
         */
        delay: {
            type: Number,
            required: false,
            validator(value) {
                return value >= 0;
            },
            default: 0,
        },

        size: {
            type: String,
            default: 'md',
            validator(value) {
                return ['sm', 'md'].indexOf(value) !== -1;
            },
        },

        /**
         * The options available for the counting. More info at: https://github.com/inorganik/countUp.js/#usage
         */
        options: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            countUp: new CountUpInstance(),
            defaultOptions: {
                startVal: 0,
                useEasing: true,
                useGrouping: true,
                separator: ',',
                decimal: '.',
                prefix: '',
                suffix: '',
            },
        };
    },
    watch: {
        shouldStart(newValue) {
            if (newValue) {
                this.start();
            }
        },
    },
    methods: {
        start() {
            this.countUp.init(this.$refs.numberCount, this.end, {
                ...this.defaultOptions,
                ...this.options,
            });
            if (this.delay > 0) {
                setTimeout(() => this.startCount(), this.delay);
            } else {
                this.startCount();
            }
        },
        startCount() {
            this.countUp.start();
        },
    },
};
</script>

<style lang="scss" scoped>
.sm {
    > div:first-child {
        @apply mb-4 w-20 h-20;
    }

    > div:last-child {
        h3 {
            @apply text-base;
        }
    }
}

.circle-badge {
    width: 80px;
    height: 80px;

    @screen md {
        width: 96px;
        height: 96px;
    }

    &.document {
        background-image: url(/images/badges/circle-badge-document.svg);
    }
    &.course {
        background-image: url(/images/badges/circle-badge-course.svg);
    }
    &.chat {
        background-image: url(/images/badges/circle-badge-chat.svg);
    }
}
</style>
